import React, { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { FlexibleLink } from './common/FlexibleLink'
import DatoCmsLink from '@m/datocms-components/DatoCmsLink'
// import find from 'lodash/find'
import filter from 'lodash/fp/filter'
import flow from 'lodash/fp/flow'
import map from 'lodash/fp/map'
import first from 'lodash/fp/first'
import orderBy from 'lodash/fp/orderBy'
import { navigate } from 'gatsby'
import ProjectImage from './project-image'
const Category = ({ category }) => {
  const responsive = typeof window !== 'undefined' && window.innerWidth <= 992

  function setShowSubMenu() {
    if (responsive) {
      var $menuBody = document.querySelector(
        'ul.category-' + category.originalId
      )

      let showClasses = { add: 'd-block', remove: 'd-none' }
      if ($menuBody) {
        if ($menuBody.childElementCount === 0 && category.topItemUrl) {
          navigate(category.topItemUrl)
        } else {
          for (let i = 0; i < $menuBody.classList.length; i++) {
            if ($menuBody.classList[i] === 'd-block') {
              showClasses.add = 'd-none'
              showClasses.remove = 'd-block'
            }
          }

          $menuBody.classList.remove(showClasses.remove)
          $menuBody.classList.add(showClasses.add)
        }
      }
    }
  }

  return (
    <div>
      <button className="h5 mb-24 cursor-pointer" onClick={setShowSubMenu}>
        <FlexibleLink
          title={category.topItemTitle}
          url={responsive ? '' : category.topItemUrl}
          className="link-hover-red"
        />
      </button>
      <ul className={`d-none d-lg-block category-${category.originalId}`}>
        {category.links.map(link => (
          <li
            className="SiteMenu-group-li mb-16"
            key={`${link.getTitle()}${link.getUrl()}`}
          >
            <FlexibleLink
              title={link.getTitle()}
              url={link.getUrl()}
              className="fw-text-light link-hover-red"
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

const SiteMenu = props => {
  const { locale, links } = props
  const alternateLink = links && links.find(l => l.hreflang !== locale)
  const data = useStaticQuery(graphql`
    query CollapsibleMenuBlockQuery {
      # Digitalzone Button
      pageSettings: allDatoCmsPageSetting {
        edges {
          node {
            locale
            digitalzoneTitle
            digitalzoneSlug
          }
        }
      }
      blocks: allDatoCmsCollapsibleMenuBlock {
        edges {
          node {
            originalId
            locale
            topItemTitle
            topItemUrl
            orderingNumber
            links {
              title
              url
              page {
                ...DatoCmsLinkFieldPage
              }
            }
          }
        }
      }
      menus: allDatoCmsMenu {
        edges {
          node {
            locale
            siteMenuImage {
              alt
              asset {
                localImage {
                  extension
                  publicURL
                  childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED)
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const currentMenu = flow(
    map('node'),
    filter(['locale', locale]),
    first
  )(data.menus.edges)
  if (!currentMenu) return null
  const { siteMenuImage } = currentMenu
  // const pageSettings = useMemo(() => find(data.pageSettings.edges, ['node.locale', locale]).node, [locale])
  const blocks = useMemo(
    () =>
      flow([
        map('node'),
        filter(['locale', locale]),
        orderBy('orderingNumber', 'asc'),
        map(block => {
          const nLinks = block.links.map(item => new DatoCmsLink(item))

          return {
            ...block,
            links: nLinks
          }
        })
      ])(data.blocks.edges),
    [data.blocks.edges, locale]
  )
  return (
    <nav className="SiteMenu py-40 py-lg-60" role="navigation">
      <div className="container d-lg-none">
        <div className="row no-gutters justify-content-end">
          {!!alternateLink && (
            <div className="col-auto">
              <FlexibleLink
                title={locale === 'en' ? 'TR' : 'EN'}
                url={alternateLink?.href || (locale === 'en' ? '/tr' : '/')}
                className="btn btn--line digital-zone px-0"
              />
            </div>
          )}
        </div>
      </div>
      <div className="container">
        <div className="SiteMenu-inner">
          <div className="d-lg-none mb-24">
            {/* <FlexibleLink
              title={pageSettings.digitalzoneTitle}
              url={pageSettings.digitalzoneSlug}
              className="h5  cursor-pointer link-hover-red"
            /> */}
          </div>
          {blocks.map(block => (
            <Category key={block.topItemTitle} category={block} />
          ))}

          <figure className="SiteMenu-figure">
            {siteMenuImage && <ProjectImage image={siteMenuImage} />}
          </figure>
        </div>
      </div>
    </nav>
  )
}

export default SiteMenu
